import React from 'react';

const CompIcon = () => {
  return (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.33366 11.3333V10.5H1.50866L1.50033 13.8333C1.50033 14.7583 2.24199 15.5 3.16699 15.5H14.8337C15.7587 15.5 16.5003 14.7583 16.5003 13.8333V10.5H10.667V11.3333H7.33366ZM15.667 3.83333H12.3253V2.16667L10.6587 0.5H7.32533L5.65866 2.16667V3.83333H2.33366C1.41699 3.83333 0.666992 4.58333 0.666992 5.5V8C0.666992 8.925 1.40866 9.66667 2.33366 9.66667H7.33366V8H10.667V9.66667H15.667C16.5837 9.66667 17.3337 8.91667 17.3337 8V5.5C17.3337 4.58333 16.5837 3.83333 15.667 3.83333ZM10.667 3.83333H7.33366V2.16667H10.667V3.83333Z" fill="currentColor"/>
    </svg>
  )
}

export default CompIcon;